import React from 'react';
import styled from 'styled-components';
import { ThemeProvider } from './theme/ThemeProvider';
import GlobalStyles from './theme/GlobalStyles';
import Header from './components/Header';
import NewsList from './components/NewsList';
import StatsDashboard from './components/StatsDashboard';
import Footer from './components/Footer';

const Main = styled.main`
  padding: 1.5rem 0;
  min-height: calc(100vh - 180px);
  
  @media (max-width: 768px) {
    padding: 1.25rem 0;
  }
  
  @media (max-width: 480px) {
    padding: 1rem 0;
  }
`;

const AppContainer = styled.div`
  max-width: ${({ $wide }) => $wide ? '1180px' : '1000px'};
  margin: 0 auto;
  
  @media (max-width: 1200px) {
    max-width: 90%;
  }
`;

function App() {
  const isStatsPath = typeof window !== 'undefined' && window.location.pathname.replace(/\/$/, '') === '/stats';

  return (
    <ThemeProvider>
      <GlobalStyles />
      <Header />
      <Main>
        <div className="container">
          <AppContainer $wide={isStatsPath}>
            {isStatsPath ? <StatsDashboard /> : <NewsList />}
          </AppContainer>
        </div>
      </Main>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
